import { render } from "./cookieDisclaimer.vue?vue&type=template&id=49f181b0"
import script from "./cookieDisclaimer.vue?vue&type=script&lang=js"
export * from "./cookieDisclaimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__